"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonRegular = void 0;

var react_1 = __importDefault(require("react"));

var button_styles_1 = require("./button-styles");

var button_types_1 = require("./button-types");

var identity_1 = require("../../identity");

var ButtonRegular = function ButtonRegular(_a) {
  var text = _a.text,
      type = _a.type,
      _b = _a.size,
      size = _b === void 0 ? button_types_1.ButtonSize.normal : _b,
      _c = _a.disabled,
      disabled = _c === void 0 ? false : _c,
      _d = _a.theme,
      theme = _d === void 0 ? identity_1.ThemeLight : _d,
      onClick = _a.onClick;

  switch (type) {
    case button_types_1.ButtonType.primary:
      {
        return react_1["default"].createElement("span", {
          className: (0, button_styles_1.buttonWrapper)(size)
        }, react_1["default"].createElement("button", {
          onClick: onClick,
          disabled: disabled,
          type: "button",
          className: (0, button_styles_1.stylePrimary)(size) + " " + (disabled ? "cursor-not-allowed" : "")
        }, text));
      }

    case button_types_1.ButtonType.secondary:
      {
        return react_1["default"].createElement("span", {
          className: (0, button_styles_1.buttonWrapper)(size)
        }, react_1["default"].createElement("button", {
          onClick: onClick,
          disabled: disabled,
          type: "button",
          className: (0, button_styles_1.styleSecondary)(size) + " " + (disabled ? "cursor-not-allowed" : "")
        }, text));
      }

    case button_types_1.ButtonType.tertiary:
      {
        return react_1["default"].createElement("span", {
          className: (0, button_styles_1.buttonWrapper)(size)
        }, react_1["default"].createElement("button", {
          onClick: onClick,
          disabled: disabled,
          type: "button",
          className: (0, button_styles_1.styleTertiary)(size) + " " + (disabled ? "cursor-not-allowed" : "")
        }, text));
      }

    case button_types_1.ButtonType.transparent:
      {
        return react_1["default"].createElement("span", {
          className: (0, button_styles_1.buttonWrapper)(size)
        }, react_1["default"].createElement("button", {
          onClick: onClick,
          disabled: disabled,
          type: "button",
          className: (0, button_styles_1.styleTransparent)(size, theme) + " " + (disabled ? "cursor-not-allowed" : "")
        }, text));
      }

    case button_types_1.ButtonType.alarm:
      {
        return react_1["default"].createElement("span", {
          className: (0, button_styles_1.buttonWrapper)(size)
        }, react_1["default"].createElement("button", {
          onClick: onClick,
          disabled: disabled,
          type: "button",
          className: (0, button_styles_1.styleAlarm)(size) + " " + (disabled ? "cursor-not-allowed" : "")
        }, text));
      }

    case button_types_1.ButtonType.special:
      {
        return react_1["default"].createElement("span", {
          className: (0, button_styles_1.buttonWrapper)(size)
        }, react_1["default"].createElement("button", {
          onClick: onClick,
          disabled: disabled,
          type: "button",
          className: (0, button_styles_1.styleSpecial)(size) + " " + (disabled ? "cursor-not-allowed" : "")
        }, text));
      }

    default:
      {
        return react_1["default"].createElement("span", {
          className: (0, button_styles_1.buttonWrapper)(button_types_1.ButtonSize.normal)
        }, react_1["default"].createElement("button", {
          onClick: onClick,
          disabled: disabled,
          type: "button",
          className: (0, button_styles_1.stylePrimary)(size) + " " + (disabled ? "cursor-not-allowed" : "")
        }, text));
      }
  }
};

exports.ButtonRegular = ButtonRegular;